import { observer } from 'mobx-react'
import { FC } from 'react'
import { uiController } from '@/controllers/uiController'
import { commonUtils } from '@/helpers/commonUtils'
// 移动端弹窗
import BuyPopup from '../mobile/BuyPopup/BuyPopup'
import PayingPopup from '../mobile/PayingPopup/PayingPopup'
import PaySuccessPopup from '../mobile/PaySuccessPopup/PaySuccessPopup'
import ContactPopup from '../mobile/ContactPopup/ContactPopup'
import LoginDialog from '../mobile/LoginDialog/LoginDialog'
import CustomerEntry from '../mobile/CustomerEntry/CustomerEntry'
// PC端弹窗
import PcLoginModal from '../pc/LoginModal/LoginModal'
import PcPaySuccessModal from '../pc/PaySuccessModal/PaySuccessModal'
import PcPayModal from '../pc/PayModal/PayModal'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    const isMobile = commonUtils.isMobile()
    if (isMobile) {
      return (
        <div>
          <BuyPopup {...uiController.buyPopupProps} />
          <PayingPopup {...uiController.payingPopupProps} />
          <PaySuccessPopup {...uiController.paySuccessPopupProps} />
          <ContactPopup {...uiController.contactPopupProps} />
          <ContactPopup {...uiController.downloadConsultationQrCodePopupProps} />
          <LoginDialog {...uiController.loginDialogProps} />
          <CustomerEntry />
        </div>
      )
    }
    return (
      <div>
        {uiController.PcLoginModalProps && <PcLoginModal {...uiController.PcLoginModalProps} />}
        {uiController.PcPaySuccessModalProps && (
          <PcPaySuccessModal {...uiController.PcPaySuccessModalProps} />
        )}
        {uiController.PcPayModalProps && <PcPayModal {...uiController.PcPayModalProps} />}
      </div>
    )
  }
)

export default CommonDialogLayout
